export function getFileName(path: string): string {
  const split = path.split('/');

  if (split.length > 1) {
    return split[split.length - 1];
  }

  return path;
}
